module.exports = __webpack_public_path__ + "static/9-0fbb5b9c4488b05031c22d87a13d85cd.jpg";